var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 235,
    viewBox: "0 0 319 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H319V235H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H319V235H0V0Z",
    fill: "#72C4FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 80,
    y: 56,
    width: 159,
    height: 123,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 73,
    width: 116,
    height: 19,
    rx: 9.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 149.972,
    y: 103.874,
    width: 66.3147,
    height: 12.1958,
    rx: 6.0979,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 149.972,
    y: 123.692,
    width: 66.3147,
    height: 12.1958,
    rx: 6.0979,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 149.972,
    y: 144.273,
    width: 66.3147,
    height: 12.1958,
    rx: 6.0979,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 104,
    width: 44,
    height: 52,
    rx: 10,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.673382 0.673382H318.327V234.327H0.673382V0.673382Z",
    stroke: "#DADBE2",
    strokeOpacity: 0.6,
    strokeWidth: 1.34676
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/imagePlaceholder.4ba7081e2e6f7ff5a650043d1d762053.svg";
export { ForwardRef as ReactComponent };